import React from 'react';

import './styles.scss';
import Loader from '../loader';
import {ITrainingDialogue} from '../../redux/trainings/interfaces';
import {TrainingCard} from '../training-card/TrainingCard';

type Props = {
  cards: ITrainingDialogue[];
  showLoader?: boolean;
  onLoadMore?: (count: number) => void;
  onClickCard: (dialogue: ITrainingDialogue) => void;
  checkedCards?: number[];
  disabledButtons?: boolean;
}

export const TrainingsCardSection = ({
  showLoader = false,
  cards,
  onClickCard
}: Props): JSX.Element => {
  function handleClickCard(dialogue: ITrainingDialogue) {
    return () => {
      onClickCard(dialogue);
    };
  }

  return <section className="trainings-card-section">
    {showLoader ? <Loader/> : <ul className="trainings-card-section__list">
      {
        cards && cards.length > 0 && cards.map((card, i) => (
          <li key={card.dialogId} className="trainings-card-section__item">
            <TrainingCard
              card={card}
              onClick={handleClickCard(card)}
            />
          </li>
        ))
      }
    </ul>}
  </section>;
};
